import PropTypes from 'prop-types';
import { SnackBarContainer } from './SnackBar.style';

const SnackBar = ({ show, message, type }) => (
  <SnackBarContainer show={show} $type={type}>
    {message}
  </SnackBarContainer>
);

SnackBar.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
  type: PropTypes.oneOf(['success', 'error']),
};

export default SnackBar;
